import { styled } from 'libs/ui/styled';
import { Content } from 'modules/account/common/components';

export const ContentStyled = styled(Content)(() => ({
  paddingBottom: 0,
  display: 'flex',
  flexDirection: 'column',
}));
